import PropTypes from 'prop-types';
import { numberFormat, unitToString } from '@/utils/unitUtils';

const IncomeStatementTable = ({ rows, labels, operationYears }) => {
  if (!rows || rows.length === 0 || !labels || labels.length === 0) {
    return null;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-xs border-collapse">
        <thead>
          <tr className="border-b border-gray-200 text-[11px] uppercase tracking-wide text-gray-500">
            <th className="sticky left-0 z-10 bg-white py-2 pr-3 text-left font-normal min-w-[180px]">Line item</th>
            {labels.map((year, idx) => {
              const opYear = operationYears?.[idx];
              const isConstruction = opYear != null && opYear < 0;
              return (
                <th
                  key={`${year}-${idx}`}
                  className={`px-2 py-2 text-right font-normal whitespace-nowrap ${isConstruction ? 'text-gray-400' : 'text-gray-500'}`}
                  title={isConstruction ? 'Construction year' : undefined}
                >
                  {year}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr
              key={row.key}
              className={`border-b border-gray-50 ${row.emphasize ? 'font-semibold text-gray-900' : 'text-gray-700'}`}
            >
              <td className="sticky left-0 z-10 bg-white py-1.5 pr-3 text-left">
                <div className="flex justify-between gap-3">
                  <span>{row.label}</span>
                  <span className="text-gray-500 font-normal text-[11px]">{unitToString(row.unit)}</span>
                </div>
              </td>
              {row.data.map((value, idx) => (
                <td key={idx} className={`px-2 py-1.5 text-right tabular-nums ${value < 0 ? 'text-rose-600' : ''}`}>
                  {value === 0 ? '—' : numberFormat(value, 2)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

IncomeStatementTable.propTypes = {
  rows: PropTypes.array,
  labels: PropTypes.array,
  operationYears: PropTypes.array,
};

export default IncomeStatementTable;
